<div class="hostWrapper" [class.overlay]="isSharedView">
  <div class="wrapper" [class.borderBottom]="!lastInList">
    <div class="container groupHeader">
      <div class="description">
        <div class="groupColor" [ngStyle]="{ 'background-color': getColor() }"></div>
        <div>
          <div class="groupName" data-ctx="pallet-layer-group-name">
            {{ palletGroup.name | translate }}
          </div>
          @if (palletGroup.loadType === 0 && palletGroup.dimensions) {
            <p class="dimensions" data-ctx="pallet-layer-group-dimensions">
              {{ palletGroup.dimensions.length }} x {{ palletGroup.dimensions.width }} x
              {{ palletGroup.dimensions.height | unit: 'length':false }}
              | {{ palletGroup.weight | unit: 'weight':false }}
            </p>
          }
        </div>
      </div>
      <div class="groupHeaderActions">
        <div
          class="groupStats"
          data-ctx="pallet-layer-group-total"
          [glTooltip]="'replicated_pallet_loads_hint'"
          [disableTooltip]="!showReplicatedLoadHint()"
          [position]="'bottom'"
          [width]="'280px'"
        >
          <div>{{ 'total_sum' | translate }}: {{ totalQuantityLabel() }}</div>
        </div>
        @if (!isSharedView && !isMobile) {
          <button
            icon-button
            type="button"
            data-ctx="button-edit-pallet-layer-group"
            #editTrigger
            (click)="toggleGroupEdit()"
            >
            <gl-icon class="moreIcon" [name]="'more'"></gl-icon>
          </button>
        }
      </div>
    </div>

    @for (row of displayRows; track $index) {
      @if (isLayerRow(row)) {
        <div class="layerRow" data-ctx="pallet-layer-row">
          <div class="layerIndent"></div>
          <div class="layerInfo">
            <span class="layerName" data-ctx="pallet-layer-name">{{
              layerTypeName(row.layer)
            }}</span>
            <span class="layerMeta" data-ctx="pallet-layer-meta">
              <span class="layerMetaItem"
                ><span class="layerMetaLabel">H: </span>{{ layerHeight(row.layer) | unit: 'length':false }}</span
              >
              <span
                class="layerMetaItem"
                [glTooltip]="'replicated_pallet_loads_hint'"
                [disableTooltip]="!showReplicatedLoadHint()"
                [position]="'bottom'"
                [width]="'280px'"
                ><span class="layerMetaLabel">{{ 'pallet_layer_load_count' | translate }}: </span
                >{{ layerQuantityLabel(row.layer) }}</span
              >
            </span>
          </div>
          <div
            class="edit layerTypeStepper drag-disabled"
            [attr.data-ctx]="isSharedView ? 'pallet-layer-type-count' : 'pallet-layer-type-stepper'"
            [glPremium]="!isSharedView && !isMobile"
          >
            @if (!isSharedView && !isMobile) {
              <span (click)="decrementLayerCount(row.layer)">-</span>
            }
            <div>{{ layerTypeCount(row.layer) }}</div>
            @if (!isSharedView && !isMobile) {
              <span (click)="incrementLayerCount(row.layer)">+</span>
            }
          </div>
        </div>
      } @else if (isInterlayerRow(row)) {
        <div class="layerRow interlayerRow" data-ctx="pallet-interlayer-row">
          <div class="layerIndent interlayerIconCell">
            <gl-icon class="interlayerIcon" name="interlayer-bar"></gl-icon>
          </div>
          <div class="layerInfo">
            <span class="layerName" data-ctx="pallet-interlayer-name">{{
              interlayerName(row.interlayer)
            }}</span>
            <span class="layerMeta" data-ctx="pallet-interlayer-meta">
              <span class="layerMetaItem">
                <span class="layerMetaLabel">H: </span
                >{{ interlayerThickness(row.interlayer) | unit: 'length':false }}
              </span>
            </span>
          </div>
          @if (showInterlayerDeleteButton && !isSharedView && !isMobile) {
            <div class="interlayerActions" [glPremium]="true">
              <button
                icon-button
                type="button"
                class="interlayerDeleteButton"
                data-ctx="button-delete-interlayer"
                [glTooltip]="'delete'"
                [position]="'top'"
                (click)="deleteInterlayer($event)"
              >
                <gl-icon [name]="'delete'"></gl-icon>
              </button>
            </div>
          }
        </div>
      }
    }
  </div>
</div>

@if (editingGroup) {
  <gl-loads-list-pallet-layer-group-edit
    #groupEdit
    glMousedownOutside
    (glMousedownOutside)="closeGroupEdit()"
    [elementToIgnore]="editTriggerEl"
    [palletGroup]="palletGroup"
    [workSpaceIndex]="workSpaceIndex"
    [stopIndex]="stopIndex"
    (closeComponent)="closeGroupEdit()"
    (panelLayoutChange)="onGroupEditLayoutChange()"
  ></gl-loads-list-pallet-layer-group-edit>
}
